// extracted by mini-css-extract-plugin
export default {"breadCrumb":"BreadCrumb_breadCrumb__9R2z7","nodeClassName":"BreadCrumb_nodeClassName__16fY3","label":"BreadCrumb_label__YFmT5","icon":"BreadCrumb_icon__V5fmt"};